import { h } from 'preact';
import { Link } from 'preact-router/match';

import './SiteHeader.scss';

const close = () => {
    document.querySelector('.site-header__menu-toggle').classList.remove('site-header__menu-toggle--open');
};

const toggle = () => {
    document.querySelector('.site-header__menu-toggle').classList.toggle('site-header__menu-toggle--open');
};

const NavLink = ({ href, children }) => (
    <Link href={href} onClick={close} class="site-header__link" activeClassName="site-header__link--active">{children}</Link>
);

const SiteHeader = ({ pages }) => (
    <header class="site-header">
        <div style="border-bottom: 1px solid #cdcdcd; padding: 12px 0 20px; text-align: center; display: none;">
            <p style="font-size: 1.5rem; font-weight: bold; color: #fff;">
                <img src="/images/logo64h.png" />
                Dr. Béres-Deák<br/>Ügyvédi Iroda
            </p>
            <p>
                {/* <a target="_blank" rel="external,noopener" href={`https://maps.google.com/?q=${encodeURIComponent('3200 Gyöngyös, Május 1. lépcső 6.')}`}>3200 Gyöngyös, Május 1. lépcső 6.</a> */}
                &nbsp;&middot;&nbsp;
                <a href="tel:+36-37-317-418">+36-37-317-418</a>
            </p>
        </div>
        <div class="site-header__navi-wrapper">
            <a class="btn--ghost" href="tel:+36 30 214 7777" style="position: absolute; right: 8px; top: 4px;">Telefon: +36 30 214 7777</a>

            <button class="site-header__menu-toggle" onClick={toggle}>
                <span class="site-header__menu-hamburger"></span>
                Menü
            </button>

            <nav class="site-header__nav">
                <NavLink href="/">Jogi tanácsadás</NavLink>
                <NavLink href="/mediacio">Gazdasági mediáció</NavLink>
                <NavLink href="/blog">Blog</NavLink>
                <NavLink href="/szakterulet">Szakterület</NavLink>
                <NavLink href="/publikaciok">Publikációk</NavLink>
                <NavLink href="/kapcsolat">Kapcsolat</NavLink>
            </nav>
        </div>
        {/* <div class="site-header__company-info">
            <Link href="/">Dr. Béres-Deák Ügyvédi Iroda</Link>
            &nbsp;&middot;&nbsp;
            <a target="_blank" rel="external,noopener" href={`https://maps.google.com/?q=${encodeURIComponent('3200 Gyöngyös, Május 1. lépcső 6.')}`}>3200 Gyöngyös, Május 1. lépcső 6.</a>
            &nbsp;&middot;&nbsp;
            <a href="tel:+36-37-317-418">+36-37-317-418</a>
        </div> */}
    </header>
);

export default SiteHeader;


// WEBPACK FOOTER //
// ./src/components/SiteHeader.js